import React, { useState, useEffect } from "react";

import arcBridge from 'frontend/js/arcBridge';
import { formatDate } from "frontend/js/helpers";

import RewardsTable from "./RewardsTable";

export const AccountProfileHistory = ({ showExpired, currentPage, rewardsPerPage, onPageChange, onToggleExpired}) => {
  const [rewardsData, setRewardsData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchRewards() {
      try {
        const response = await arcBridge.getCustomerRewardsHistory();
        if (response.success) {
          const formatted = response.results.map((reward) => ({
            reward: reward.description,
            received: formatDate(reward.received_at),
            amount: `$${reward.amount.toFixed(2)}`,
            balance: `$${reward.balance.toFixed(2)}`,
            expires: formatDate(reward.expires_at),
            isExpired: new Date(reward.expires_at) < new Date(),
          }));
          setRewardsData(formatted);
        } else {
          setRewardsData([]);
        }
      } catch (error) {
        console.error("Error fetching rewards history:", error);
        setRewardsData([]);
      } finally {
        setLoading(false);
      }
    }
    fetchRewards();
  }, []);

  // Filter based on showExpired
  const filtered = showExpired
    ? rewardsData
    : rewardsData.filter((r) => !r.isExpired);

  // Check if any expired rewards exist
  const hasExpiredRewards = rewardsData.some((r) => r.isExpired);

  // Pagination
  const indexOfLast = currentPage * rewardsPerPage;
  const indexOfFirst = indexOfLast - rewardsPerPage;
  const current = filtered.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filtered.length / rewardsPerPage);

  if (loading) return <p>Loading rewards...</p>;

  return (
    <>
      <RewardsTable rewardsData={current} noData={filtered.length === 0} />

      <div className={`flex flex-col justify-between mt-6 lg:flex-row lg:items-center ${!hasExpiredRewards ? "lg:justify-end" : ""}`}>
        {hasExpiredRewards && (
          <button
            onClick={() => onToggleExpired()}
            className="order-2 button button-primary !w-max lg:order-1"
          >
            {showExpired ? "Hide Expired" : "Show Expired"}
          </button>
        )}

        <ul className="flex p-0 border-t border-[#ECEBEB] mb-10 order-1 lg:order-2 lg:mb-0">
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((pageNum) => (
            <li
              key={pageNum}
              className={`list-none cursor-pointer border-t-2 ${currentPage === pageNum ? "border-[#00263E]" : ""}`}
              onClick={() => onPageChange(pageNum)}
            >
              <span className={`px-3 py-1 b3 ${currentPage === pageNum ? "text-[#00263E]" : "text-[#54565A]"}`}>
                {pageNum}
              </span>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default AccountProfileHistory;